import { IObservable, Observable } from '@1js/oil-externals/rx';

import { SearchConfigService } from '../../search-results/services/search-config.service';
import { FilesFastSuggestionProvider } from '../fast-suggestion-providers/files.fast-suggestion-provider';
import { SearchResultType } from '../search-instrumentation.service';

export class FileSearchSuggestionProvider extends FilesFastSuggestionProvider {

    public static searchConfigService: SearchConfigService;

    public createStream(searchText: string): IObservable<any> {
        if (FileSearchSuggestionProvider.searchConfigService.config.fastODCFileProviderEnabled && searchText?.trim() !== '') {
            FileSearchSuggestionProvider.searchInstrumentationService.setRenderedProviderResults(SearchResultType.File, []);
            return Observable.empty();
        } else {
            return super.createStream(searchText);
        }
    }

    public getId(): string {
        return 'files';
    }
}
